import styled from 'styled-components'
import { rgba } from 'polished'
import backgroundPattern from './background.png'
import { Title, media, Link, Spinner } from 'ui'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  min-width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;

  ${media.lessThan('tablet')`
    grid-template-columns: 1fr;
    grid-template-rows: 9rem 1fr;
  `}

  ${media.lessThan('phone')`
    height: auto;
  `}
`

const LogoColumn = styled.section`
  position: relative;
  background-color: ${({ theme }) => theme.colours.background};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  ${media.lessThan('tablet')`
    padding: 0;
  `}
`

const LogoColumnContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.large};
  background: ${({ theme }) => `linear-gradient(45deg, ${theme.colours.third} 0%, ${theme.colours.primary} 100%)`};

  &:before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${backgroundPattern});
    background-position: center;
    background-size: 500px auto;
    opacity: .5;
  }

  ${media.lessThan('tablet')`
    padding-left: 7em;
    justify-content: flex-start;
    border-radius: 0;
    background: none;

    &:before {
      background-size: 36rem auto;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      box-shadow: 0 -13px 10px -5px ${({ theme }) => theme.colours.background} inset;
    }
  `}

  ${media.lessThan('phone')`
    padding-left: 3rem;
  `}

  a {
    cursor: default;
    pointer-events: none;
  }
`

const FormColumn = styled.section`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: ${({ theme }) => theme.colours.background};
  padding-left: 7rem;
  padding-right: 5rem;

  ${media.greaterThan('smallDesktop')`
    padding-left: 10rem;
  `}

  ${media.lessThan('tablet')`
    height: calc(100vh - 9rem);
    align-items: flex-start;
  `}

  ${media.lessThan('phone')`
    padding-left: 3rem;
    padding-right: 3rem;
  `}
`

const FormContent = styled.div`
  width: 100%;
  max-width: 34.7rem;
  padding-top: 10rem;

  ${media.lessThan('tablet')`
    padding-top: 0;
  `}
`

const MainTitle = styled(Title)`
  font-weight: bold;
  letter-spacing: -.124rem;
  line-height: 1;
  font-size: 2.6rem;
  text-indent: -2px;
  margin-bottom: 3rem;

  ${media.greaterThan('smallDesktop')`
    font-size: 3.4rem;
    margin-bottom: 2rem;
  `}
`

const Form = styled.form`
  width: 100%;
`

const LoginOptions = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 2rem 0 4rem;
`

const LinkForgotPassword = styled(Link)`
  font-size: 1.2rem;
  padding-right: .3em;
  margin-left: auto;

  &:after {
    display: none;
  }
`

const LinkRegister = styled(Link)`
  font-size: 1em;
`

const Register = styled.p`
  margin: 0;
  padding-top: 6rem;
  font-size: 1.3rem;
  font-weight: normal;

  ${media.lessThan('phone')`
    padding-top: 3rem;
  `}
`

const SpacedSpinner = styled(Spinner)`
  margin-left: 1.6rem;
`

const FormErrorMessage = styled.p`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 2.5rem;
  color: ${({ theme }) => theme.colours.error};
  background: ${({ theme }) => rgba(theme.colours.error, 0.1)};
  border-radius: ${({ theme }) => theme.radius.small};
  padding: 1rem 1.6rem;
  line-height: 1.6;
`

const PasswordExpiredMessage = styled.p`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 2.5rem;
  color: ${({ theme }) => theme.colours.primary};
  background: ${({ theme }) => rgba(theme.colours.primary, 0.1)};
  border-radius: ${({ theme }) => theme.radius.small};
  padding: 1rem 1.6rem;
  line-height: 1.6;
  a {
    color: ${({ theme }) => theme.colours.primary};
    font-weight: 700;
  }
`

const FormSuccessMessage = styled.p`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colours.success};
  background: ${({ theme }) => rgba(theme.colours.success, 0.1)};
  border-radius: ${({ theme }) => theme.radius.small};
  padding: 1rem 1.6rem;
  line-height: 1.6;
`

export {
  Container,
  LogoColumn,
  FormColumn,
  FormContent,
  MainTitle,
  Form,
  LinkForgotPassword,
  LinkRegister,
  LoginOptions,
  Register,
  SpacedSpinner,
  FormErrorMessage,
  LogoColumnContent,
  FormSuccessMessage,
  PasswordExpiredMessage,
}
